import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=d1ece450"
import script from "./EditClient.vue?vue&type=script&lang=js"
export * from "./EditClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports